<template>
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		viewBox="0 0 22 14" style="enable-background:new 0 0 22 14; fill:none;stroke:#E75300;" xml:space="preserve">
		<g id="Comps">
			<g id="E-2.1---Full-User---Set-to-Public" transform="translate(-655.000000, -2657.000000)">
				<g id="Group-44" transform="translate(-11.000000, 0.000000)">
					<g id="Group-23" transform="translate(311.000000, 2371.000000)">
						<g id="Icon---Visible" transform="translate(355.000000, 286.000000)">
							<g id="Group-22">
								<path id="Rectangle" class="st0" d="M0.6,7l1.3,1.5c2.2,2.7,5.6,4.2,9.1,4.2c3.5,0,6.8-1.6,9-4.3l1.3-1.7L20,5.1
									c-2.2-2.7-5.5-4.3-9-4.3c-3.5,0-6.8,1.6-8.9,4.4L0.6,7z"/>
								<circle id="Oval" class="st0" cx="11" cy="7" r="3"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>
<script>
export default {
	name: "IconEyeVisible"
};
</script>

<style lang="scss" scoped>
	.st0 {
		fill:none;
		stroke:#E75300;
	}
</style>

